import React, { useState } from 'react'
import { IconButton } from '@st-operations/uikit/src/v2'
import Form from '_components/form/Form'

import { getFieldsForSchemaKind, getSchemaFoSchemaKind } from '../utils'
import './styles.scss'

const NewDataFormat = (props) => {
  const [item, setItem] = useState({})
  const { fields, schema, onSave, type } = props

  const onChange = (value, name) => {
    const updatedItem = {
      ...item,
      [name]: value?.value || value,
    }
    setItem(updatedItem)
  }
  const addItem = () => {
    onSave(item, type)
    setItem({})
  }
  return (
    <div className="sg-config-data-container">
      <Form
        fields={fields ? getFieldsForSchemaKind(item, fields) : []}
        schema={schema ? getSchemaFoSchemaKind(item, schema) : {}}
        item={item}
        onChange={onChange}
        className="sg-config-data-format"
      />
      <IconButton onClick={addItem} iconProps={{ icon: 'add', type: 'fill' }} />
    </div>
  )
}

export default NewDataFormat
